export class TypeDocument {
    id: number;
    name: string;
}


